var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.doc.tieneNc === "no" && _vm.doc.tieneNd === "no"
      ? _c("div", [_vm._v(" No tiene documentos asociados ")])
      : _vm.doc.tieneNc === "no" && _vm.doc.tieneNd === "si"
      ? _c("div", [_vm._v(" ND ")])
      : _vm.doc.tieneNd === "no" && _vm.doc.tieneNc === "si"
      ? _c("div", [_vm._v(" NC ")])
      : _vm.doc.tieneNd === "si" && _vm.doc.tieneNc === "si"
      ? _c("div", [_vm._v(" ND/NC ")])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }